<div
    [ngClass]="
        isP2POnly
            ? 'tw-text-[12px] tw-items-center'
            : 'tw-flex-col tw-items-start sm:tw-flex-row sm:tw-items-center tw-text-[16px]'
    "
    class="tw-bg-blue-100 tw-w-full tw-text-[#003A70] tw-gap-2 sm:tw-gap-3 tw-flex tw-font-semibold sm:tw-w-fit tw-my-2 tw-rounded-[12px] sm:tw-rounded-full sm:tw-py-2 tw-py-3 tw-px-3 sm:tw-px-9"
>
    <div [ngClass]="isP2POnly ? 'tw-w-full sm:tw-w-auto' : ''">
        {{ "PRODUCT_MATCHING.TOTAL_PRODUCTS" | translate }}:
    </div>
    <div
        class="tw-flex tw-w-full sm:tw-w-auto tw-gap-3 tw-justify-around tw-items-center"
    >
        <div
            *ngIf="!isP2POnly"
            class="tw-flex tw-gap-2 tw-items-center tw-font-bold"
        >
            <span
                class="tw-bg-blue-200 tw-rounded-full tw-h-[25px] tw-w-[25px] tw-flex tw tw-items-center tw-justify-center tw-p-2"
                >{{ bankProductsTotal || 0 }}</span
            >
            <span>{{ "PRODUCT_MATCHING.BANK_PRODUCT" | translate }}</span>
        </div>
        <div class="tw-flex tw-gap-2 tw-items-center tw-font-bold">
            <span
                class="tw-bg-blue-200 tw-rounded-full tw-h-[25px] tw-w-[25px] tw-flex tw tw-items-center tw-justify-center tw-p-2"
                >{{ P2P_ProductsTotal || 0 }}</span
            >
            <span>{{ "PRODUCT_MATCHING.P2P_PRODUCT" | translate }}</span>
        </div>
        <div
            *ngIf="!isP2POnly"
            class="tw-flex tw-gap-2 tw-items-center tw-font-bold"
        >
            <span
                class="tw-bg-blue-200 tw-rounded-full tw-h-[25px] tw-w-[25px] tw-flex tw tw-items-center tw-justify-center tw-p-2"
                >{{ DigitalBanks_ProductsTotal || 0 }}</span
            >
            <span>{{ "PRODUCT_MATCHING.DIGITAL_BANKS" | translate }}</span>
        </div>
    </div>
</div>
